//require('dotenv').config();

const stylesConfig = {
  BACKGROUND_URL: process.env.REACT_APP_BACKGROUND_URL,
  THEME: process.env.REACT_APP_THEME,
  APPNAME: process.env.REACT_APP_APPNAME,
  SHOW_APPNAME: process.env.REACT_APP_SHOW_APPNAME,
  APP_VERSION: process.env.REACT_APP_VERSION,
  LOGO_ALT: process.env.REACT_APP_LOGO_ALT,
  LOGO_LINK: process.env.REACT_APP_LOGO_LINK,
  FOOTER_LINK: process.env.REACT_APP_FOOTER_LINK,
  FOOTER_TEXT: process.env.REACT_APP_FOOTER_TEXT,
  LANG: process.env.REACT_APP_LANG,
  TC_LINK: process.env.REACT_APP_TC_LINK,
  TC_LINK_EN: process.env.REACT_APP_TC_LINK_EN,
  TC_LINK_DE: process.env.REACT_APP_TC_LINK_DE,
  COMPANY: process.env.REACT_APP_COMPANY,
  HELP_EMAIL: process.env.REACT_APP_HELP_EMAIL,
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL,
};

export default stylesConfig;

export const appConfig = {
  RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY,
  ALLOW_SIGNUP: process.env.REACT_APP_ALLOW_SIGNUP,
  DEBUG_WS: process.env.REACT_APP_DEBUG_WS,
  URL: process.env.REACT_APP_URL,
  URL_REST: process.env.REACT_APP_URL_REST,
  URL_REST_V2: process.env.REACT_APP_URL_REST_V2,
  URL_API: process.env.REACT_APP_URL_API,
  URL_MP: process.env.REACT_APP_URL_MP,
  SHOW_MESSENGER_SELECTOR: process.env.REACT_APP_SHOW_MESSENGER_SELECTOR,
  DEFAULT_LOCALE: process.env.REACT_APP_DEFAULT_LOCALE,
  GTM_KEY: process.env.REACT_APP_GTM_KEY,
  GTM_AUTH: process.env.REACT_APP_GTM_AUTH,
  GTM_PREVIEW: process.env.REACT_APP_GTM_PREVIEW,
  STATUS_PAGE_URL: process.env.REACT_APP_STATUS_PAGE_URL,
  GRAFANA_EMBED_URL: process.env.REACT_APP_GRAFANA_EMBED_URL,
  GRAFANA_URL: process.env.REACT_APP_GRAFANA_URL,
  EMAIL2SMS_URL: process.env.REACT_APP_EMAIL2SMS_URL,
  MT_API_URL: process.env.REACT_APP_MT_API_URL,
  BETA: process.env.REACT_APP_BETA === 'true',
  OPT_OUT_URL: process.env.REACT_APP_OPT_OUT_URL,
  INBOUND_NUMBERS_URL: process.env.REACT_APP_URL_INBOUND_NUMBERS,
  ESMES_SMSC_IDS_URL: process.env.REACT_APP_ESMES_SMSC_URL,
  USER_ACTIVITY_TIMEOUT_LOGOUT: process.env.REACT_APP_USER_ACTIVITY_TIMEOUT_LOGOUT,
  VIBER_URL: process.env.REACT_APP_VIBER_URL,
  META_URL: process.env.REACT_APP_META_URL,
  CHAT_PROXY_URL_WS: process.env.REACT_APP_CHAT_PROXY_URL_WS,
  APP_ID: process.env.REACT_APP_ID,
  VIBER_CALLBACK_URL: process.env.REACT_APP_VIBER_CALLBACK_URL,
  VIBER_MESSAGE_URL: process.env.REACT_APP_VIBER_MESSAGE_URL,
  CLICKUP_REDIRECT_URL: process.env.REACT_APP_CLICKUP_REDIRECT_URL,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_URL_WS: process.env.REACT_APP_URL_WS,
  OAUTH2_PROVIDER: process.env.REACT_OAUTH2_PROVIDER,
  OAUTH2_BASE_URL: process.env.REACT_APP_OAUTH2_BASE_URL,
  KEYCLOAK_ISSUER_URI: process.env.REACT_APP_KEYCLOAK_ISSUER_URI,
  KEYCLOAK_CLIENT_ID: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  KEYCLOAK_ACTION_REDIRECT_URI: process.env.REACT_APP_KEYCLOAK_ACTION_REDIRECT_URI,
  REACT_APP_IS_VIBER_ALLOWED: process.env.REACT_APP_IS_VIBER_ALLOWED,
  /**
   * Phase 2: set `REACT_APP_VIBER_TEMPLATE_MANAGEMENT_ENABLED=true` to show Viber template CRUD (Channels, campaign “Template” type, legacy /channels/viber route).
   * Phase 1 default: disabled (templates hidden from portal).
   */
  VIBER_TEMPLATE_MANAGEMENT_ENABLED: process.env.REACT_APP_VIBER_TEMPLATE_MANAGEMENT_ENABLED === 'true',
  /**
   * Phase 2: set `REACT_APP_VIBER_ID_REGISTRATION_ENABLED=true` for in-portal Viber ID connect wizard.
   * Phase 1 default: disabled — registration is handled outside the portal.
   */
  VIBER_ID_REGISTRATION_ENABLED: process.env.REACT_APP_VIBER_ID_REGISTRATION_ENABLED === 'true',
  GENAI_URL: process.env.REACT_APP_GENAI_URL,
  GENAI_USE_MOCK: process.env.REACT_APP_GENAI_USE_MOCK,
  AMPLITUDE_API_KEY: process.env.REACT_APP_AMPLITUDE_API_KEY,
  /** When false (default), events from admin routes (/administration, /admin) are not sent to Amplitude. Set to 'true' to re-enable. */
  AMPLITUDE_TRACK_ADMIN: process.env.REACT_APP_AMPLITUDE_TRACK_ADMIN === 'true',
  CLICKUP_DOCUMENTAION_URL: process.env.REACT_APP_CLICKUP_DOCUMENTAION_URL,
};
